
import { apiCall } from './apiCall';
  
  
  
export default function topupApi() {
  return {
    create: (data,token) => apiCall('/topUpMerchent',data, token),
    getTopups: (data,token) => apiCall('/getTopUpHistory',data, token)
    
  };
}
